// extracted by mini-css-extract-plugin
export default {"sidebarHeading":"sidebar_sidebarHeading__k9NuD","sidebarDesc":"sidebar_sidebarDesc__XwEGp"};